/**
 * Copie `text` dans le presse-papier.
 * Rejette sans presse-papier (http hors localhost) ou sur refus.
 *
 * @example
 * copyText("https://app.qualneo.fr/jury/abc") // Promise<void>
 */
export function copyText(text: string): Promise<void> {
  return Promise.resolve().then(() => {
    if (!("clipboard" in navigator)) throw new Error("Presse-papier indisponible sur cette page.")
    return navigator.clipboard.writeText(text)
  })
}
